import React from "react";
import "./precisionClicker.css";
import { Game } from "./components/Game";

/** Full-screen game — reached from the Precision Clicker menu */
export default function PrecisionClickerPlay() {
  return (
    <div className="game-container" style={{ minHeight: '100vh', minWidth: '100vw' }}>
      <Game />
    </div>
  );
}
